import { Panel } from 'foundations-components/transitional/components/Panel';
import { SIDE_PANEL_WIDTH } from 'automation-ui-core/constants/ui';
import { useCanvasTopOffset } from 'automation-ui-canvas/utils/styleUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const ConfigPanel = ({
  align = 'left',
  canvasScrollElementRef,
  children,
  dataTestId,
  isEmbedded = false,
  width = SIDE_PANEL_WIDTH
}) => {
  const canvasTopOffset = useCanvasTopOffset(canvasScrollElementRef);
  const adjustedTopOffset = isEmbedded ? 0 : canvasTopOffset;
  return /*#__PURE__*/_jsx(Panel, {
    align: align,
    position: "absolute",
    insetBlockStart: `${adjustedTopOffset}px`,
    blockSize: `calc(100vh - ${adjustedTopOffset}px)`,
    "data-test-id": dataTestId,
    width: width
    /* This panel doesn't expand to fit the SegmentationFilters side panel,
       causing it to be invisible in Safari.
       https://git.hubteam.com/HubSpot/ProductSupport/issues/74490 */,
    overflow: "visible",
    children: children
  });
};
export default ConfigPanel;